import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SaveLocationMutation = gql`
   mutation SaveLocation($location: LocationInput!) {
      location: saveLocation(location: $location) {
         locationId
         accountId
         name
         houseNumber
         directionalPrefix
         streetName
         streetNameSuffix
         directionalPostfix
         city
         state
         postalCode
         comment
         country
         timeZoneId
         isE911Validated
      }
   }
`;
